export enum WorkFlowStepTypeEnum {
    //Начальное состояние
    initial = 1,
    //Конечное состояние
    final = 2,
    //Изменение статуса заявки
    requestStatusChange = 3
}